import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import { DialogPropsBase } from '../../common/props/commonFormProps';
import { renderNewTextField, renderCheckbox, renderErrorInfoText } from '../../common/forms/FieldCreators';
import { LocalForm, Control, Errors } from 'react-redux-form';
import nameof from '../../utils/nameof';
import { localizations } from '../../localization/localization';
import { EmailSettingsModel } from '../../common/models/CommonModels';
import * as formValidators from '../../common/validators/formValidators'

type SubmitType = (data: EmailSettingsModel) => void;
type CancelType = () => void;

interface EditProps {
    model?: EmailSettingsModel
}

const initialState: EmailSettingsModel = { id: undefined, email: "", emailDetails: "", emailVisible: true }

type AddProps = DialogPropsBase<SubmitType, CancelType> & EditProps

const AddEditEmailDialog: React.SFC<AddProps> = (props) => {

    const editMode = !!props.model;

    return (
        <Dialog open={props.isOpen}>
            <LocalForm hideNativeErrors onSubmit={(values) => props.onSubmit(values)} initialState={props.model || initialState}>
                <DialogTitle>{editMode ? localizations.forms.editEmail : localizations.forms.addEmail}</DialogTitle>
                <DialogContent>
                    <Grid container direction="column" spacing={4}>
                        <Grid item>
                            <Control.text model={`.${nameof<EmailSettingsModel>("email")}`} component={renderNewTextField} label={localizations.common.email}
                                validators={{
                                    isRequired: formValidators.required,
                                    isEmail: formValidators.isEmail,
                                }} 
                                validateOn={["blur", "change"]}
                                />
                            <Errors model={`.${nameof<EmailSettingsModel>("email")}`}
                                wrapper={renderErrorInfoText}
                                messages={{
                                    isRequired: localizations.validation.required,
                                    isEmail: localizations.validation.notAnEmail,
                                }}
                                show={{touched: true, focus: false}}
                            />
                        </Grid>
                        <Grid item>
                            <Control.text model={`.${nameof<EmailSettingsModel>("emailDetails")}`} component={renderNewTextField} label="Selite" />
                        </Grid>
                        <Grid item>
                            <FormControlLabel control={<Control.checkbox model={`.${nameof<EmailSettingsModel>("emailVisible")}`} component={renderCheckbox} />} label={localizations.settings.showEmail} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" type="submit">{editMode ? localizations.actions.save : localizations.actions.add}</Button>
                    <Button variant="outlined" onClick={() => props.onCancel()}>{localizations.actions.cancel}</Button>
                </DialogActions>
            </LocalForm>
        </Dialog>
    );
}

export default AddEditEmailDialog;


// WEBPACK FOOTER //
// ./src/account/forms/AddEditEmailDialog.tsx